module.exports = __webpack_public_path__ + "img/pin_substitution_orange.1eb9f4eb.svg";